import ThemeContext from "config/context/themeContext";
import styles from "css/plugins.module.css";
import { useContext, useEffect, useState } from "react";
import PluginsMain from "../components/plugins/PluginsMain";
import GuiContext from "../config/context/guiContext";
import useTitle from "../config/useTitle";

const Plugins = () => {
  useTitle("Plugins");
  const { dark: isDark } = useContext(ThemeContext);

  const {
    URL,
    userData: { guiname, id },
    selected: { selectedServer },
  } = useContext(GuiContext);

  const [plugins, setPlugins] = useState("");
  const [userPlugins, setUserPlugins] = useState("");

  async function fetchPlugins() {
    try {
      const data = {
        server_url: selectedServer,
      };
      const response = await fetch(`${URL}/api/plugins/all`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      if (!response.ok) {
        throw new Error("Request failed with status: " + response.status);
      }
      return await response.json();
    } catch (error) {
      console.error("Error fetching plugins:", error);
      return null;
    }
  }

  async function fetchUserPlugins() {
    try {
      // Implement the logic to fetch user plugins here
      // and return the fetched data
      const url = `${URL}/api/plugins/user`;
      const data = {
        guiname,
        server_url: selectedServer,
        account_id: id,
      };

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();
      setUserPlugins(result);
    } catch (error) {
      console.error("Error fetching user plugins:", error);
      return null;
    }
  }

  useEffect(() => {
    async function fetchData() {
      const data = await fetchPlugins();
      if (data) {
        setPlugins(data);
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    fetchUserPlugins();
  }, []);

  const refreshData = async () => {
    const pluginsData = await fetchPlugins();
    if (pluginsData) {
      setPlugins(pluginsData);
    }
    const userPluginsData = await fetchUserPlugins();
    if (userPluginsData) {
      setUserPlugins(userPluginsData);
    }
  };

  return (
    <div className={`${isDark ? styles.dark : ""} container`}>
      <PluginsMain
        plugins={plugins}
        userPlugins={userPlugins}
        refreshData={refreshData}
      />
    </div>
  );
};

export default Plugins;
